/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "U1JTNjllOWtib25uVWpKS00wSlNhQVdyY1dYSUxTYzRkTGRUWUF0R0d5RT18aXF2aWFpbmMtM2ZjMDIxMmY=",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://dev-cm.dapstudies.com",
config.sitecoreSiteName = process.env.REACT_APP_SITECORE_SITE_NAME || "PatientHub",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://edge.sitecorecloud.io/api/graphql/v1",
config.layoutServiceConfigurationName = process.env.REACT_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "default",
module.exports = config;